module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_hiramatsu@3x-7af434bb7bb1c3b413083cb9cd31b9c6.webp";